import * as types from '../actions';

export default function setIsPlacingSeed(isPlacingSeed) {
  return {
    type: types.VIEWER_SET_IS_PLACING_SEED,
    isPlacingSeed,
  };
}
